import React from "react";

export const ShareIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      width="19"
      height="19"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.83333 12.3331V3.51165L11.5774 6.25572L12.7559 5.07721L8 0.321289L3.24408 5.07721L4.42259 6.25572L7.16667 3.51165V12.3331H8.83333ZM15.5 15.6665V8.16647H13.8333V15.6665H2.16667V8.16647H0.5V15.6665C0.5 16.5869 1.24619 17.3331 2.16667 17.3331H13.8333C14.7538 17.3331 15.5 16.5869 15.5 15.6665Z"
        fill="#AFAFAF"
      />
    </svg>
  );
};
